import { api, ensureCsrfCookie } from '@/services/api';
import type { User } from '@/types';

export interface LoginCredentials {
    email: string;
    password: string;
    remember?: boolean;
}

export async function login(credentials: LoginCredentials): Promise<User> {
    await ensureCsrfCookie();
    const response = await api.post<{ user: User }>('/api/admin/v1/login', credentials);
    return response.data.user;
}

export async function logout(): Promise<void> {
    await api.post('/api/admin/v1/logout');
}

export async function fetchCurrentUser(): Promise<User> {
    const response = await api.get<{ user: User }>('/api/admin/v1/user');
    return response.data.user;
}
